import { BehaviorSubject } from 'rxjs';

const alertSubject = new BehaviorSubject({});

export const alertService = {
    observable: alertSubject.asObservable(),
    set: set,
    close: close,
    success,
    error,
    confirm
}

function set(title, message) {
    alertSubject.next({
        title: title,
        message: message,
        show: true,
        type: 'info'
    });
}

function success(message) {
    set("Succes!", message);
}

function error(message) {
    set("Atentie!", message);
}

function close() {
    alertSubject.next({});
}

function confirm(title, message, onConfirm, onCancel) {
    alertSubject.next({
        title: title,
        message: message,
        show: true,
        type: 'confirm', // Setăm tipul ca fiind confirm
        onConfirm: onConfirm,
        onCancel: onCancel
    });
}
